var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.32227 9.00039C1.32227 4.75991 4.75991 1.32227 9.00039 1.32227C13.2409 1.32227 16.6785 4.75991 16.6785 9.00039C16.6785 13.2409 13.2409 16.6785 9.00039 16.6785C4.75988 16.6785 1.32227 13.2409 1.32227 9.00039ZM8.49426 13.0494H9.50652V8.3539H10.9651L9.00039 4.95138L7.03569 8.3539H8.49426V13.0494Z",
    fill: "#B34A23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.6a9ae70a2093d56065d91b0023f111dc.svg";
export { ForwardRef as ReactComponent };